module.exports = __webpack_public_path__ + "img/57.1d8f485e.png";